const truncateNumber = (number) => {
    if (!number) return "";
    if (number >= 1000) {
        const truncatedNumber = (number / 1000).toFixed(1);
        return `${truncatedNumber}k`;
    }
    return number.toString();
};

export default truncateNumber;